import { Loader } from "@commonlibs";
import { GiftCardLoaderContainer, GiftCardLoaderRoot } from "./GiftCardLoader.styles";

function GiftCardLoader() {
    return (
        <GiftCardLoaderRoot>
            <GiftCardLoaderContainer>
                <Loader />
            </GiftCardLoaderContainer>
        </GiftCardLoaderRoot>
    );
}

export default GiftCardLoader;
